<template>
  <div class="wl-step">
    <header class="wl-step__header">
      <img
        v-if="headerIcon"
        :src="headerIcon"
        loading="lazy"
        alt=""
        :aria-hidden="true"
        class="wl-step__header-icon"
      />
      <h1
        class="wl-step__header-title"
        :class="{ 'wl-step__header-title--no-icon': !headerIcon }"
      >
        {{ title }}
      </h1>
      <div v-if="displayBadge" class="wl-step__badge">
        <img
          v-if="badgeIcon"
          :src="badgeIcon"
          loading="lazy"
          alt=""
          :aria-hidden="true"
          class="wl-step__badge-icon"
        />
        <p class="wl-step__badge-text">{{ badgeText }}</p>
      </div>
      <slot />
    </header>
    <div v-if="subText" class="wl-step__sub-text">
      <tz-markdown :content="subText" />
    </div>
  </div>
</template>

<script>
import TzMarkdown from '@trazi/tz-markdown/src/tz-markdown.vue';

export default {
  name: 'WlStep',
  components: {
    TzMarkdown
  },
  props: {
    headerIcon: {
      type: String,
      default: null
    },
    title: {
      type: String,
      required: true
    },
    subText: {
      type: String,
      default: null
    },
    badgeText: {
      type: String,
      default: null
    },
    badgeIcon: {
      type: String,
      default: null
    }
  },
  computed: {
    displayBadge() {
      return !(!this.badgeText && !this.badgeIcon);
    }
  }
};
</script>
